import script from "./packageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./packageList.vue?vue&type=script&setup=true&lang=ts"

import "./packageList.vue?vue&type=style&index=0&id=532c2ee7&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532c2ee7"]])

export default __exports__